import './SynergyCommonSupplierComparePage.scss';
import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {Grid} from "@mui/material";
import {useStores} from "../../../stores";
import {SynergyCommonSupplierReviewMainTable} from "./SynergyCommonSupplierReviewMainTable";
import {SynergyCommonSupplierToolbar} from "./SynergyCommonSupplierToolbar";

export const SynergyCommonSupplierCompare: React.FC = observer(() => {
    const {synergyStore} = useStores();

    useEffect(() => {
        synergyStore.commonSuppliersDelegate.init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <Grid component="section"
                 className="page-item step synergy-common-supplier-step"
                 container justifyContent="center">
        <Grid item xs={12}>
            <SynergyCommonSupplierToolbar isParent={false}/>
            <SynergyCommonSupplierReviewMainTable/>
        </Grid>
    </Grid>
})
